import React, { useEffect, useState } from 'react';
import Sale from './Sale';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/s/:id" element={<Sale />} />
      </Routes>
    </Router>
  )
}

export default App;

